import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ChatBot from './components/ChatBot';
import BackToTop from './components/BackToTop';
import CookieConsent from './components/CookieConsent';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import IndustriesPage from './pages/IndustriesPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import BlogPage from './pages/BlogPage';
import ErpSmokeShopsPage from './pages/ErpSmokeShopsPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import CookiesPage from './pages/CookiesPage';
import PartnerPage from './pages/PartnerPage';
import LaunchPad5Page from './pages/LaunchPad5Page';
import WhiteLabelAgencyPage from './pages/WhiteLabelAgencyPage';
import { HelmetProvider } from 'react-helmet-async';

/**
 * Main App component that sets up routing and global layout
 * Author: VB Entreprise
 * 
 * This component provides the main application structure with:
 * - React Router for navigation between pages
 * - Global header and footer components
 * - AI-powered chatbot for visitor engagement
 * - Responsive layout structure
 */
function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-white">
          {/* Global header with navigation */}
          <Header />
          
          {/* Main content area with routing */}
          <main className="pt-16">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/industries" element={<IndustriesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/erp-smokeshops" element={<ErpSmokeShopsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/cookies" element={<CookiesPage />} />
              <Route path="/partner" element={<PartnerPage />} />
              <Route path="/launchpad5" element={<LaunchPad5Page />} />
              <Route path="/white-label-agency" element={<WhiteLabelAgencyPage />} />
            </Routes>
          </main>
          
          {/* Global footer */}
          <Footer />
          
          {/* AI-powered chatbot for 24/7 engagement */}
          <ChatBot />
          
          {/* Back to top button */}
          <BackToTop />
          
          {/* Cookie consent banner */}
          <CookieConsent />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;